export const normalizeEmbeddedPlusNumber = (value, fallback = "") => {
  const rawValue =
    value === null || value === undefined ? String(fallback || "").trim() : String(value).trim();

  if (!rawValue) {
    return String(fallback || "").trim();
  }

  const embeddedPlusIndex = rawValue.indexOf("+", rawValue.startsWith("+") ? 1 : 0);
  return embeddedPlusIndex > 0
    ? rawValue.slice(0, embeddedPlusIndex).trim() || String(fallback || "").trim()
    : rawValue;
};

export const pickSipDisplayValue = (...values) => {
  for (const value of values) {
    const normalizedValue = normalizeEmbeddedPlusNumber(value);
    if (normalizedValue) {
      return normalizedValue;
    }
  }

  return "";
};
